import React from "react";
import { UserAvatar } from "../../../User";
import getMemberNickname from "../../../../helpers/get-member-nickname";
import "./styles.scss";

const OptionMember = ({value, onChange, $locale}) => {
    const className = "option-member";

    if (value.value === null) {
        return (
            <div className={`${className} option-cancel`} onClick={() => onChange(null)}>
                {value.label}
            </div>
        )
    }

    return (
        <div className={className} onClick={() => onChange(value.id)}>
            <UserAvatar photo={value.previewUrl} initials={getMemberNickname(value, $locale)} size="medium" />
            <div className={`${className}--wrapper`}>
                <div className={`${className}--header`}>
                    <span className={`${className}--label`}>{value.label}</span>
                    <div className={`${className}--roles`}>
                        {value.roles?.map(role => (
                            <span key={role.id} className={`${className}--role`}>{$locale.getProperty(role, 'title')}</span>
                        ))}
                    </div>
                </div>
                <span className={`${className}--info`}>{$locale.getProperty(value, 'company')}</span>
                <span className={`${className}--info -two-line`}>{$locale.getProperty(value, 'regalia')}</span>
            </div>
        </div>
    );
}

export default OptionMember;
